import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../config/firebase';
import { request } from './client';

/**
 * Sign in with Google via Firebase popup, then authenticate with our backend.
 * Returns the same shape as apiLogin: { token, user }
 */
export const apiGoogleLogin = async () => {
  const result = await signInWithPopup(auth, googleProvider);
  const idToken = await result.user.getIdToken();

  return request('/auth/google', {
    method: 'POST',
    body: { idToken },
  });
};
